import { Button, Modal } from "react-bootstrap"
import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import StripeSepaContainer from "./stripe/StripeSepaContainer"
import { integrationKeyStripe } from "../../integration/IntegrationConstants"
import { Intl } from "../../state/helpers/IntlProps"

type Props = {
    intl: Intl
    contactId: string,
    publicKey: string,
    onClose: () => void,
    onSubmit: () => void,
    saveAndChargeLater: boolean,
    integrationKey: string,
    testMode: boolean,
}

const NewSEPABankAccountOnFileModal = (props: Props) => {

    const getModal = (integrationKey: string) => {
        switch (integrationKey) {
        case integrationKeyStripe:
            return <StripeSepaContainer
                contactId={props.contactId}
                publicKey={props.publicKey}
                saveAndChargeLater={props.saveAndChargeLater}
                onSubmit={props.onSubmit}
                onClose={props.onClose}
                integrationKey={props.integrationKey}
                testMode={props.testMode}
            />
        default:
            return <div>
                <FormattedMessage
                    id="common.sepa.new_sepa_modal.not_supported"
                    defaultMessage="The payment integration is not currently supporting SEPA direct debit account" />
            </div>
        }
    }


    return (
        <Modal {...props}
            onHide={props.onClose}
            show={true}
            backdrop="static">
            <Modal.Header>
                <Modal.Title>
                    <FormattedMessage
                        id="common.sepa.new_sepa_modal.title"
                        defaultMessage="Add a new SEPA direct debit account" />
                </Modal.Title>

            </Modal.Header>
            <Modal.Body>
                {getModal(props.integrationKey)}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    onClick={props.onClose}
                    variant="secondary">
                    <FormattedMessage
                        id="common.sepa.new_sepa_modal.close_modal"
                        defaultMessage="Close" />
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default injectIntl(NewSEPABankAccountOnFileModal)


// WEBPACK FOOTER //
// ./src/common/sepa/NewSEPABankAccountOnFileModal.tsx